import { Injectable } from '@angular/core';
import { AppInjector } from '../../app-injector';
import { AccessPolicy, PolicyPostRequest, Statement } from '@mitel/cloudlink-sdk/admin';
import { AdminService } from 'src/app/core/services/admin.service';

@Injectable({
	providedIn: 'root'
})

export class IntegPolicyService {

	private adminService: AdminService;

	constructor(  ) 
	{
	}

	initServices()
	{
		if ( !this.adminService )
			this.adminService = AppInjector.injector.get(AdminService);
	}

	removeAccountPolicyIfItExists( account: any, statement: Statement)
	{
		this.initServices();
		// remove the entity policy statement
		if ( account['policyId'] === undefined ) // nothing to remove
		{
			return Promise.resolve({});
		}
		return this.adminService.getPolicy(account.accountId, account['policyId']).then( policy => {
			console.log("Here are the account policies", policy);
			const foundPolicy = policy.statements.find(stmt => {
				return stmt.statementId === statement.statementId;
			});
			if ( foundPolicy )
			{
				return this.removeStatementFromPolicy(account, policy, statement);
			}
			else
				return Promise.resolve({});
		});
	}

	// entity can be User or Account. It should have userId
	removeStatementFromPolicy(entity: any, policy: AccessPolicy, statement: Statement) 
	{
		this.initServices();
		return this.adminService.removeStatementFromPolicy(
			entity.accountId, policy.policyId, statement.statementId).then(data => {
				console.log("this is the returned data", data)
				return data;
			}).catch(err => {
				console.log("Failed to remove policy", err);
				throw err;
			})
	}

	addStatementToPolicy( entity: any, statement: Statement ): Promise<AccessPolicy>
	{
		this.initServices();

		if ( entity['policyId'] != undefined )
		{
			return this.adminService.getPolicy(entity.accountId, entity['policyId']).then( policy => {
				console.log("Here are the account policies", policy);
				const foundPolicy = policy.statements.find(stmt => {
					return stmt.statementId === statement.statementId;
				});
				if (foundPolicy) {
					console.log("We found the policy exists")
					return policy;
				}
				else
				{
					return this.updatePolicyWithStatement( entity.accountId, policy, statement);
				}
			}) 
			.catch(err => {
				console.log("Here is the error from getting policies", err)
				throw err;
			});
		}
		else
			return this.createPolicyWithStatement( entity.accountId, statement);
	}

	createPolicyWithStatement(accountId: string, statement: Statement): Promise<AccessPolicy>
	{
		this.initServices();

        const policy: PolicyPostRequest = {
            name: accountId + '-policy',
            statements: [
                statement
            ]
        };
		return this.adminService.createUserPolicy(policy, accountId);
	}

	updatePolicyWithStatement( accountId: string, policy: AccessPolicy, statement: Statement)
	{
		this.initServices();
		return this.adminService.updatePolicy( accountId, policy.policyId, null, [statement] );
	}

}
